import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navbar from './components/navbar';
import Home from './components/Home';
import About from './components/About';
import Announcements from './components/Announcements';
import Events from './components/Events';
import Contributions from './components/Contributions';
import Profile from './components/Profile';
import Gallary from './components/Gallary';
import Contact from './components/Contact';
import Departments from './components/Departments';
import Ministries from './components/Ministries';
import Blog from './components/Blog';
import ScrollToTop from './components/scrollTop';
import DeptJoinForm from './components/DeptJoinForm';
import MinistryJoinForm from './components/MinistryJoinForm';
import EventDetails from './components/EventDetails';
import EventTicket from './components/EventTicket';
import PaymentCallback from './components/PaymentCallback';
import ProtectedRoute from "./components/Admin/ProtectedRoute";
import AdminDashboard from "./components/Admin/AdminDashboard";
import AdminLogin from "./components/Admin/AdminLogin";
import VisitorTracker from "./components/VisitorTracker";
import Footer from "./components/Footer";
import DeptMembers from "./components/Admin/DeptMembers";
import MinistryMembers from "./components/Admin/MinistryMembers";
import ManageAnnouncements from "./components/Admin/ManageAnnouncements";
import ManageContributions from "./components/Admin/ManageContributions";
import ManageEvents from "./components/Admin/ManageEvents";
import ManageBlogs from "./components/Admin/ManageBlogs";
import ManageLeaders from "./components/Admin/ManageLeaders";
import ManageGallery from "./components/Admin/ManageGallery";
import UsersDetails from "./components/Admin/UserDetails";
import ManagePledges from "./components/Admin/ManagePledges";
import HeavenlyVoyagers from "./components/HeavenlyVoyagers";
import CalvaryMinisters from "./components/CalvaryMinisters";
import RevelationOfLove from "./components/RevelationOfLove";
import Subscribed from "./components/Admin/Subscribed";
import NotFound from "./components/NotFound";
import BsReg from "./components/BsReg";
import AdminBsReg from "./components/Admin/AdminBsReg";
import Resources from "./components/Resources";
import Register from "./components/Register";
import AdminRegistrations from "./components/Admin/AdminRegistrations";
import TicketDashboard from "./components/Admin/TicketDashboard";
import TicketOrders from "./components/Admin/TicketOrders";
import EventTicketView from "./components/Admin/EventTicketView";
import QrCheckin from "./components/Admin/QrCheckin";

// 👇 create a wrapper component to manage layout
function AppLayout() {
  const location = useLocation();

  // Check if current route starts with /admin
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      <ScrollToTop />
      <VisitorTracker />

      {/* 👇 Only show Navbar & Footer if NOT on admin routes */}
      {!isAdminRoute && <Navbar />}
      <div className="min-h-screen">
        <AppRoutes />
      </div>
      {!isAdminRoute && <Footer />}
    </>
  );
}

// 👇 split routes into a separate component
function AppRoutes() {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/announcements" element={<Announcements />} />
      <Route path="/events" element={<Events />} />
      <Route path="/contributions" element={<Contributions />} />
      <Route path="/departments" element={<Departments />} />
      <Route path="/ministries" element={<Ministries />} />
      <Route path="/profiles" element={<Profile />} />
      <Route path="/gallery" element={<Gallary />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/bible-study" element={<BsReg />} />
      <Route path="/register" element={<Register />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/departments/join" element={<DeptJoinForm />} />
      <Route path="/ministries/join/:ministryName" element={<MinistryJoinForm />} />
      <Route path="/ministries/revelation-of-love" element={<RevelationOfLove />} />
      <Route path="/ministries/heavenly-voyagers" element={<HeavenlyVoyagers />} />
      <Route path="/ministries/calvary-ministers" element={<CalvaryMinisters />} />
      <Route path="/events/:eventId/ticket" element={<EventTicket />} />
      <Route path="/events/:eventId" element={<EventDetails />} />
      <Route path="/payment/callback" element={<PaymentCallback />} />
      <Route path="*" element={<NotFound />} />

      {/* Admin routes */}
      <Route path="/admin" element={<AdminLogin />} />
      <Route
        path="/admin/dashboard/*"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="visitors" replace />} />
        <Route path="visitors" element={<UsersDetails />} />
        <Route path="dept-members" element={<DeptMembers />} />
        <Route path="ministry-members" element={<MinistryMembers />} />
        <Route path="announcements" element={<ManageAnnouncements />} />
        <Route path="contributions" element={<ManageContributions />} />
        <Route path="pledges" element={<ManagePledges />} />
        <Route path="events" element={<ManageEvents />} />
        <Route path="blog" element={<ManageBlogs />} />
        <Route path="leaders" element={<ManageLeaders />} />
        <Route path="gallery" element={<ManageGallery />} />
        <Route path="subscribed" element={<Subscribed />} />
        <Route path="bs-details" element={<AdminBsReg />} />
        <Route path="registrations" element={<AdminRegistrations />} />
        {/* Phase 4: Ticketing */}
        <Route path="ticket-dashboard" element={<TicketDashboard />} />
        <Route path="ticket-orders" element={<TicketOrders />} />
        <Route path="ticket-events" element={<EventTicketView />} />
        <Route path="qr-checkin" element={<QrCheckin />} />
        <Route path="*" element={<Navigate to="visitors" replace />} />
      </Route>
    </Routes>
  );
}

// 👇 Main App
function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
